<template>
  <SoTooltip :text="tooltip" :disabled="!hasValue">
    <span class="text-no-wrap">{{ display }}</span>
  </SoTooltip>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoTooltip from "@/components/SoTooltip.vue"

  // Renders a date table cell that shows the short date with the full
  // date-time on hover. Shared by both service-config tables. When there is no
  // underlying value the tooltip is disabled (the cell still shows the em dash
  // produced by the model's display getters).
  export default defineComponent({
    components: {
      SoTooltip,
    },
    props: {
      display: {
        type: String,
        required: true,
      },
      tooltip: {
        type: String,
        required: true,
      },
      hasValue: {
        type: Boolean,
        default: true,
      },
    },
  })
</script>
